<div class="row main-box mb-0 mx-0 py-3" *ngIf="!isOutreachModal">
    <div class="col-xs-12">
        <div class="checkbox-nice cursor-pointer">
            <input type="checkbox" [(ngModel)]="sendOutreachEmail" (change)="isSendOutreachEmailChange()" [id]="outreachEmailId" [name]="outreachEmailId"/> 
            <label for="{{outreachEmailId}}" class="mb-0 ml-1">
                Send Outreach to Candidates
            </label>
        </div>
    </div>
</div>

<div *ngIf="isOutreachModal">
    <div class="row main-box p-4" *ngIf="!loadingFlag">
        <div class="col-xs-12">
            <p>Select the <b>Job Matches</b> you want to include in the <b>Outreach Email</b>:</p>
            <table class="table table-bordered table-responsive" style="overflow-y: auto !important;">
                <thead>
                    <tr style="line-height: 1.5; background-color: #03a9f426;">
                        <th class="text-center" style="width: 50px;">
                            <input type="checkbox" [(ngModel)]="selectAllJobMatches"
                                (change)="toggleSelectAllJobMatches()" tooltip="Select All">
                        </th>
                        <th>REQ #</th>
                        <th>Role Name</th>
                        <th style="width:14%">
                            Job Match Details
                        </th>
                        <th>Client/BU</th>
                        <th>Status</th>
                        <th>Location</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let jobMatch of jobMatches; let i = index">
                        <tr class="position-relative" [ngClass]="{'disablescreen job-match-disabled': jobMatch.outreachDisabled}">
                            <td class="text-center position-relative">
                                <span class="outreach-active-job" *ngIf="jobMatch.outreachActiveJob" tooltip="Current job"><i class="fas fa-arrow-alt-circle-right"></i></span>
                                <input type="checkbox" [(ngModel)]="jobMatch.jobMatchSelected"
                                    (change)="onJobMatchSelectionChange()" [disabled]="jobMatch.outreachDisabled">
                            </td>
                            <td class="font-bold">
                                <a tooltip="Go to Job" container="body" placement="top"
                                    (click)="goToRequisitionsJob(jobMatch)">
                                    <span>{{jobMatch.requisitionNumber | truncatePipe:20}}
                                        <span *ngIf="jobMatch.requisitionNumber.length > 20">..</span>
                                    </span>
                                </a>
                            </td>
                            <td class="font-bold">
                                <span class="">{{jobMatch.jobTitle}}</span>
                            </td>
                            <td class="text-left">
                                <span>
                                    <div>
                                        <app-candidate-card-icons context="candidateCurrentJobMatches" [candidate]="jobMatch"
                                            [candidateAdditionalDetails]="jobMatch.candidateJobMatchCardDetails.candidateAdditionalDetails"
                                            [candidateSalaryDurationOptions]="salaryDurationOptions" [jobTypeList]="jobTypeList">
                                        </app-candidate-card-icons>
                                    </div>
                                    <div *ngIf="jobMatch.contractDuration">
                                        {{jobMatch.contractDuration | contractDurationPipe}}
                                    </div>
                                </span>
                            </td>
                            <td>
                                <span tooltip="{{jobMatch.companyName}}">
                                    {{jobMatch.companyName | truncatePipe:40}}
                                    <span *ngIf="jobMatch.companyName && jobMatch.companyName.length > 40">..</span>
                                </span>
                            </td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <div tooltip="{{jobMatch.jobMatchStep}}">
                                        {{(jobMatch.jobMatchStep ) | truncatePipe:30}}
                                        <span *ngIf="jobMatch.jobMatchStep && jobMatch.jobMatchStep.length > 30">..</span>
                                    </div>
                                    <span *ngIf="jobMatch.outreachIconStatus && jobMatch.outreachIconStatus.outreachIconEnabled"
                                        class="node position-relative pl-2" style="bottom: 1px; font-size: 11px;"
                                        [tooltip]="jobMatch.outreachIconStatus.outreachTooltipMessage"
                                        placement="bottom">
                                        <i class="fas fa-paper-plane text"
                                            [ngClass]="{ 
                                            'dark-orange': jobMatch.outreachIconStatus.outreachSaved || jobMatch.outreachIconStatus.outreachNotCompleted, 
                                            'green-yellow': jobMatch.outreachIconStatus.outreachCompleted || jobMatch.outreachIconStatus.outreachNotAMatch, 
                                            'black': jobMatch.outreachIconStatus.outreachSent, 
                                            'red': jobMatch.outreachIconStatus.outreachNoResponse,
                                            'outreach-red-border outreach-red-border-send-outreach': jobMatch.outreachIconStatus.outreachNotCompleted || jobMatch.outreachIconStatus.outreachNotAMatch }">
                                        </i>
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div tooltip="{{jobMatch.jobLocationText}}">
                                    {{jobMatch.jobLocationText && jobMatch.jobLocationText != '' ?
                                    (jobMatch.jobLocationText | truncatePipe:30) : '-'}}
                                    <span *ngIf="jobMatch.jobLocationText && jobMatch.jobLocationText.length > 30">..</span>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
            <p class="mb-3">Do you want us to send the candidate an outreach email to determine their
                interest?
            </p>
            <div class="pull-right">
                <button class="btn btn-danger mr-2" (click)="close()">No</button>
                <button class="btn btn-primary" (click)="sendSelectedJobMatchOutreachEmail()" [disabled]="!hasJobMatches">Yes</button>
            </div>
        </div>
    </div>
    <div class="row main-box p-4" *ngIf="loadingFlag">
        <div class="col-xs-12">
            <div class="skeleton-paragraph width-50 skeleton-loading mb-3"></div>
            <table class="table table-bordered">
                <thead>
                    <tr style="line-height: 1.5; background-color: #03a9f426;">
                        <th style="width: 50px;"></th>
                        <th>REQ #</th>
                        <th>Role Name</th>
                        <th style="width:14%">Job Match Details</th>
                        <th>Client/BU</th>
                        <th>Status</th>
                        <th>Location</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of [0, 1, 2]">
                        <td *ngFor="let cell of [0, 1, 2, 3, 4, 5, 6]">
                            <div class="skeleton-paragraph width-75 skeleton-loading my-1"></div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="skeleton-paragraph width-75 skeleton-loading mb-3"></div>
            <div class="pull-right d-flex">
                <div class="skeleton-loading mr-2" style="height: 34px; width: 52px;"></div>
                <div class="skeleton-loading" style="height: 34px; width: 52px;"></div>
            </div>
        </div>
    </div>
</div>